import { render, staticRenderFns } from "./DeletePost.vue?vue&type=template&id=7ead8b9f&scoped=true&"
import script from "./DeletePost.vue?vue&type=script&lang=js&"
export * from "./DeletePost.vue?vue&type=script&lang=js&"
import style0 from "./DeletePost.vue?vue&type=style&index=0&id=7ead8b9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ead8b9f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ead8b9f')) {
      api.createRecord('7ead8b9f', component.options)
    } else {
      api.reload('7ead8b9f', component.options)
    }
    module.hot.accept("./DeletePost.vue?vue&type=template&id=7ead8b9f&scoped=true&", function () {
      api.rerender('7ead8b9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/modals/DeletePost.vue"
export default component.exports